import Swiper from 'swiper/bundle';

class Slider {
  setupCookiesSlider(): void {
    const featured_cookies_thumbs = new Swiper('.featured-cookies-thumbs', {
      slidesPerView: 1,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          centeredSlides: false,
        },
      },
    });

    const featured_cookies_slider = new Swiper('.featured-cookies-slider', {
      effect: 'fade',
      thumbs: {
        swiper: featured_cookies_thumbs,
      },
    });

    featured_cookies_thumbs.on('slideChange', () => {
      featured_cookies_slider.slideTo(featured_cookies_thumbs.activeIndex);
    });
    featured_cookies_slider.on('slideChange', () => {
      featured_cookies_thumbs.slideTo(featured_cookies_slider.activeIndex);
    });
  }

  setupBoxesSlider(): void {
    const boxes_slider = new Swiper('.boxes-slider', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 6,
          spaceBetween: 0,
        },
      },
    });
  }

  setupIcecreamsSlider(): void {
    const icecreams_slider = new Swiper('.icecreams-slider', {
      slidesPerView: 'auto',
    });

    icecreams_slider.on('slideChange', () => {
      if (icecreams_slider.isEnd) {
        icecreams_slider.el.classList.add('reach-end');
      } else {
        icecreams_slider.el.classList.remove('reach-end');
      }
    });
  }

  setupSpreadsSlider(): void {
    const spreads_slider = new Swiper('.spreads-slider', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 50,
          centeredSlides: false,
        },
      },
    });

    if (document.querySelector('.spreads-slider')) {
      spreads_slider.slideTo(1);
    }
  }

  setupKnowhowSlider(): void {
    const knowhow_slider = new Swiper('.know-how-slider', {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  setupProductsSlider(): void {
    const product_images_thumbs = new Swiper('.product-images-thumbs', {
      slidesPerView: 'auto',
      spaceBetween: 15,
      breakpoints: {
        1200: {
          spaceBetween: 10,
        },
      },
    });

    const product_images_slider = new Swiper('.product-images-slider', {});

    if (document.querySelector('.product-images-thumbs')) {
      const product_images_slider = new Swiper('.product-images-slider', {
        thumbs: {
          swiper: product_images_thumbs,
        },
      });
    }

    product_images_thumbs.on('slideChange', () => {
      product_images_slider.slideTo(product_images_thumbs.activeIndex);
    });
    product_images_slider.on('slideChange', () => {
      product_images_thumbs.slideTo(product_images_slider.activeIndex);
    });
  }

  setupCarouselSlider(): void {
    const carousel_slider = new Swiper('.carousel-slider', {
      slidesPerView: 1.5,
      centeredSlides: true,
      spaceBetween: 22,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        560: {
          slidesPerView: 2.5,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 5,
          centeredSlides: false,
        },
      },
    });

    if (document.querySelector('.carousel-slider')) {
      carousel_slider.slideTo(2);
    }
  }

  setupHeroSlider(): void {
    document.querySelectorAll('.hero-images-slider').forEach((el) => {
      const container = el as HTMLElement;
      const pagination = container.querySelector('.swiper-pagination') as HTMLElement | null;

      new Swiper(container, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  }

  setup(): void {
    this.setupCookiesSlider();
    this.setupBoxesSlider();
    this.setupIcecreamsSlider();
    this.setupSpreadsSlider();
    this.setupKnowhowSlider();
    this.setupProductsSlider();
    this.setupCarouselSlider();
    this.setupHeroSlider();
  }
}

export default Slider;
